import React, { useEffect, useState, useRef} from "react";
import store from "@/redux/store";
import CommunicationCycleReducer, {getState, getTasks, saveTask, newTaskEvent, setChangedItems, setUpdate} from '@/reducers/CommunicationCycle';

import moment from 'moment';
import { Dialog, DialogBackdrop, DialogPanel, DialogTitle } from '@headlessui/react'
import {addCalenderItem, hideModal} from '@/reducers/ModalPopup';

import { ExclamationTriangleIcon } from '@heroicons/react/24/outline'
import BaseDialog from "@/components/dialog/BaseDialog";
import ContactBladView from '@/views/Dossiers/detail/ContactBlad';

function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}

export default function Worklog(props) {
    
    const modalOptions = props?.modalProps?.options;
    const [popup, setPopup] = useState((<></>))

    const cancelEventHandler = (event) =>  {
        if(props?.closeModal) {
            props?.closeModal();   
        }
    };
    
    const confirmEvent = (event) =>  {
        if(props.modalOptions && props.modalOptions.action) {
            props.modalOptions.action(props.modalOptions);
        }
    }

    return (
        <BaseDialog {...props} nofooter>

            <div className="sm:flex w-full">
              <div className="mt-3  w-full sm:ml-4 sm:mt-0 sm:text-left">
                <DialogTitle as="h3" className="text-base font-semibold leading-6 text-gray-900">
                  Opslaan contactblad
                </DialogTitle>
                <div className="mt-2 flex w-full">
                    <ContactBladView data={modalOptions?.item} closeModal={props?.closeModal}/>
                </div>
              </div>
            </div>
                    
        </BaseDialog>
    )
}